export function isAcceptKey(event: any) {
    return ["Space", "Enter"].includes(event.code);
  }
  